import { useTranslation } from "react-i18next"
import LoadingSpinner from "../../../Components/Components/LoadingSpinner"
import useGetProductIndexWithMask from "../../../Components/BasketPage/Hooks/useGetProductIndexWithMask"
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from "../../../Helpers/CustomConverter"

const OrderPositions = ({ items, isLoading, isArchive }) => {
    const { t } = useTranslation()
    return (<div className='table-responsive table-items'  >
        <table className='table table-bordered'>
            <thead>
                <tr>
                    <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: '9%' }}>
                        Indeks
                    </th>
                    <th style={{ alignContent: 'center', verticalAlign: 'middle', fontWeight: 'normal', width: 'auto' }}>
                        Nazwa<br />Cecha
                    </th>
                    <th style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right', fontWeight: 'normal', width: '5%' }}>
                        Rabat
                    </th>
                    <th style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right', fontWeight: 'normal', width: '7%' }}>
                        Cena netto PLN
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle', fontWeight: 'normal', width: '10%' }}>
                        Zamówione<br />Zarezerwowane
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle', fontWeight: 'normal', width: '10%' }}>
                        Zadysponowane<br />Zrealizowane
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle', fontWeight: 'normal', width: '5%' }}>
                        Jedn.
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle', fontWeight: 'normal', width: '7%' }}>
                        Wartośc netto PLN
                    </th>
                    {!isArchive && <th style={{ textAlign: 'right', verticalAlign: 'middle', fontWeight: 'normal', width: '12%' }}>
                        <span>Przewidywany</span>
                        <br />
                        <span>Termin</span>
                        <br />
                        <span>Dostawy</span>
                    </th>}

                </tr>
            </thead>
            <tbody>
                {items && !isLoading && items.map((item, index) => {
                    return <TableItems key={index} item={item} isArchive={isArchive} />
                })}
            </tbody>
        </table>
        {isLoading && <LoadingSpinner width={2} height={2} />}
        {!isLoading && items && items.length === 0 && (
            <div style={{ textAlign: "center" }}>
                {t("message_norecords_orders_items_page")}
            </div>
        )}
    </div>
    )
}

const TableItems = ({ item, isArchive }) => {
    const { getProductIndexWithMask } = useGetProductIndexWithMask()
    return (
        <tr className='hoverable-row'>
            <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>
                {getProductIndexWithMask(item.index)}
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle' }}>
                {CapitalizeFirstLowercaseRest(item.name)}<br />{CapitalizeFirstLowercaseRest(item.description)}
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {item.discount}%
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {ConvertPriceToString(item.priceNetto, null)}
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {item.qtyStock}<br />{item.rezQty}
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {item.dyspQty}<br />{item.sellQty}
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {item.jmh}
            </td>
            <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {ConvertPriceToString(item.priceNetto * item.qtyStock, null)}
            </td>
            {!isArchive && <td style={{ alignContent: 'center', verticalAlign: 'middle', textAlign: 'right' }}>
                {CapitalizeFirstLowercaseRest(item.ptdText)}
            </td>}

        </tr>
    )
}

export default OrderPositions